package game.entity

import game.*

class Boulder(val spriteId: String, val weight: Int = 1) : Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        if (game.player.bracer.strength >= weight) {
            val destCol = col + game.player.colVel
            val destRow = row + game.player.rowVel

            if (destCol < 0 || destCol >= ROOM_WIDTH || destRow < 0 || destRow >= ROOM_HEIGHT) {
                // Boulder is off screen. Remove
                room.removeEntity(this)

                return true
            } else {
                val tile = room[destCol, destRow]
                val type = tile.type

                val entity = room.getEntityAt(destCol, destRow)

                if ((type == TileType.Floor || type == TileType.Lava) && entity == null) {
                    col = destCol
                    row = destRow

                    return true
                } else if (type == TileType.Hole) {
                    room.removeEntity(this)

                    game.playSound("fall")

                    room.addEntity(AnimationEntity().apply {
                        sprite = game.getSpriteById("$spriteId-fall")
                        col = destCol
                        row = destRow
                    })

                    return true
                } else if (type == TileType.Water) {
                    room.removeEntity(this)

                    game.playSound("splash")

                    room.addEntity(AnimationEntity().apply {
                        sprite = game.getSpriteById("splash")
                        col = destCol
                        row = destRow
                    })

                    return true
                }
            }
        }

        game.message = game.text("Message_TooHeavy")

        return false
    }
}